import { DEFAULT_LOCALE } from '@standardnotes/i18n';
import { action, makeObservable, observable } from 'mobx';
class LocalizationStore {
    constructor() {
        this.currentLocale = DEFAULT_LOCALE;
        this.availableLocales = {};
        this.availableLocalesFailedToLoad = false;
        makeObservable(this, {
            currentLocale: observable,
            availableLocales: observable,
            availableLocalesFailedToLoad: observable,
            setCurrentLocale: action,
            setAvailableLocales: action,
            setAvailableLocalesFailedToLoad: action,
        });
    }
    setCurrentLocale(locale) {
        this.currentLocale = locale;
    }
    setAvailableLocales(catalog) {
        this.availableLocales = catalog;
        this.availableLocalesFailedToLoad = false;
    }
    setAvailableLocalesFailedToLoad() {
        this.availableLocales = {};
        this.availableLocalesFailedToLoad = true;
    }
}
export const localizationStore = new LocalizationStore();
